"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIMovetexDeliveryOrdersWebhookPayload = void 0;
const imovetex_planning_changed_order_entry_1 = require("./imovetex-planning-changed-order-entry");
function parseIMovetexDeliveryOrdersWebhookPayload(data) {
    if (data.deliveryOrders !== null && typeof data.deliveryOrders === 'object')
        data.deliveryOrders = data.deliveryOrders.map((x) => (0, imovetex_planning_changed_order_entry_1.parseIMovetexPlanningChangedOrderEntry)(x));
    return data;
}
exports.parseIMovetexDeliveryOrdersWebhookPayload = parseIMovetexDeliveryOrdersWebhookPayload;
